import { render, staticRenderFns } from "./ClinicStep.vue?vue&type=template&id=764c2d06&scoped=true&"
import script from "./ClinicStep.vue?vue&type=script&lang=js&"
export * from "./ClinicStep.vue?vue&type=script&lang=js&"
import style0 from "./ClinicStep.vue?vue&type=style&index=0&id=764c2d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c2d06",
  null
  
)

export default component.exports